import jwtDecode from 'jwt-decode';
import { db } from '@/vendors/firebase/firebase';

const ls = require('local-storage');

export default {
  async loginWithMagicLinkToken(token) {
    return Promise.resolve(ls.set('shopToken', token));
  },

  async logout() {
    return Promise.resolve(ls.unsetShopToken('shopToken'));
  },

  async getCurrentShopInfos() {
    const shopToken = ls.get('shopToken');
    const { shopId } = jwtDecode(shopToken);

    const docRef = db.collection('shops').doc(shopId);

    let shopDoc = await docRef.get().then((doc) => {
      if (doc.exists) {
        return doc.data();
      }
      return null;
    }).catch((error) => {
      console.log(error);
      return null;
    });
    shopDoc = { shopId, ...shopDoc };
    return shopDoc;
  },
};
